<template>
  <div
    v-if="(contract.id && item.accountNo && contract.groupService === 'PAYMENT') || type === 'mc'"
    class="form-detail"
  >
    <h1 class="d-flex justify-content-between">
      <span>Thông tin nhận thanh toán</span>
      <b-button v-if="!item?.bankVerify" class="btn btn-primary" size="sm" @click="comfirm"
        >Xác thực</b-button
      >
    </h1>
    <Content
      title="Dạng TKNH"
      :content="item.bankAccType | transformData(Config.mcBankAccType)"
    ></Content>
    <Content title="Chủ tài khoản" :content="item.holderName"></Content>
    <Content title="Số tài khoản" :content="item.accountNo"></Content>
    <Content title="Ngân hàng" :content="item.bankName"></Content>
    <Content title="Chi nhánh" :content="item.branch"></Content>
    <Content v-if="item.bankCityName" title="Tỉnh/Thành Phố" :content="item.bankCityName"></Content>
    <Content
      title="MC muốn nhận tiền trực tiếp về TK"
      :content="item.enableReceived ? 'Có' : 'Không'"
    ></Content>
    <Content
      title="Trạng thái xác thực ngân hàng"
      :content="item.bankVerify ? 'Đã xác thưc' : 'Chưa xác thực'"
    ></Content>
  </div>
</template>
<script>
  import Content from './Content.vue'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
      comfirm: {
        type: Function,
        default: () => {},
      },
      type: {
        type: String,
        default: () => 'contract',
      },
    },
    components: { Content },
    data() {
      return {}
    },
    computed: {},
  }
</script>

<style scoped></style>
